import React from "react";
import { Button, Form, Input } from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

const DynamicInputFields = ({ form, field_key, inputStyle, formStyle }) => {
  const getFieldName = () => {
    return Array.isArray(field_key) ? field_key : [field_key];
  };

  if (typeof form.getFieldValue(field_key) === "boolean") {
    form.setFieldValue(field_key, undefined);
  }

  const existing = form.getFieldValue(getFieldName());
  const hasExistingRows = Array.isArray(existing) && existing.length > 0;
  // Avoid seeding a blank remarks row when the field already has values
  // (or when parent only mounts this after "others" is checked with data).
  const listInitialValue = hasExistingRows ? undefined : [{ remarks: "" }];

  const {
    marginLeft,
    marginRight,
    marginInline,
    maxWidth,
    width,
    ...itemStyle
  } = formStyle || {};

  const listOffsetStyle = {
    marginLeft,
    marginRight,
    marginInline,
    maxWidth: maxWidth || 850,
    width: width || "100%",
    boxSizing: "border-box",
  };

  return (
    <div className="dynamic-input-fields" style={listOffsetStyle}>
      <Form.List name={[...getFieldName()]} initialValue={listInitialValue}>
        {(fields, { add, remove }) => {
          const handleAdd = () => {
            const formValues = form.getFieldValue(getFieldName());
            const lastFieldValue = formValues?.[formValues.length - 1]?.remarks;

            if (lastFieldValue) {
              add({ remarks: "" });
            }
          };

          // Hide rows that are empty placeholders when there is at least one
          // real row — still show a single empty row when editing "others".
          const visibleFields = fields;

          return (
            <>
              {visibleFields.map((field, index) => (
                <div
                  key={field.key}
                  className="dynamic-input-fields-row"
                  style={{
                    display: "flex",
                    flexWrap: "nowrap",
                    alignItems: "center",
                    gap: 8,
                    marginBottom: 8,
                    width: "100%",
                    maxWidth: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <div
                    className="dynamic-input-fields-row__input"
                    style={{
                      flex: "1 1 auto",
                      minWidth: 0,
                      maxWidth: "100%",
                    }}
                  >
                    <Form.Item
                      {...field}
                      style={{ ...itemStyle, marginBottom: 0, width: "100%" }}
                      name={[field.name, "remarks"]}
                    >
                      <Input.TextArea
                        rows={2}
                        style={{
                          width: "100%",
                          boxSizing: "border-box",
                          ...inputStyle,
                          maxWidth: "100%",
                        }}
                        placeholder={`Enter remarks ${index + 1}`}
                        autoComplete="off"
                      />
                    </Form.Item>
                  </div>
                  {index !== 0 && (
                    <Button
                      className="dynamic-input-fields-row__remove"
                      icon={<MinusOutlined />}
                      onClick={() => remove(field.name)}
                      style={{ flexShrink: 0, alignSelf: "center" }}
                      aria-label="Remove remarks"
                    />
                  )}
                </div>
              ))}
              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  type="dashed"
                  onClick={handleAdd}
                  icon={<PlusOutlined />}
                >
                  Add Other
                </Button>
              </Form.Item>
            </>
          );
        }}
      </Form.List>
    </div>
  );
};

export default DynamicInputFields;
